<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="banner">
        <van-swipe ref="banner" class="elbanner" autoplay="5000" indicator-active-color="#FFFFFF">
          <van-swipe-item v-for="item in bannerlist" :key="item.Id">
            <img :src="item.Img" class="bannerimg" @click="toBanner(item.type, item.Url, item.Id)" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="square_consult">
        <div class="square_consult_box">
          <div class="right_Consult" v-for="(item, index) in list" :key="index"
            @click="toLive(item.Id, item.Title, item.CoverUrl)">
            <div class="livetiaozhuan">
              <div class="picture">
                <!-- <img src="../../assets/images/play.png" alt="" class="play"> -->
                <img :src="baseURL + item.CoverUrl" />
              </div>
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>

    <img class="share" src="../../assets/images/circle_share.png" @click="showSharePanel = true" />
    <SharePanel :show="showSharePanel" @close="closeSharePanel" />

    <div v-if="gocheck == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注！本内容仅对专业人士开放，请先完成对应的注册!</div>
        <div class="btrowi">
          <div class="clo" @click="gocheck = false">取消</div>
          <div class="jum" @click="gohfh()">去注册</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck1 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对ACMED会员开放，请您登录后验证身份，谢谢!</div>
        <div class="btrowi">
          <div class="clo" @click="gocheck1 = false">取消</div>
          <div class="jum" @click="goacmedzc()">去验证</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck2 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对华肤荟认证用户开放，请您登录后验证身份，谢谢！</div>
        <div class="btrowi">
          <div class="clo" @click="gocheck2 = false">取消</div>
          <div class="jum" @click="goacmedrz()">去验证</div>
        </div>
      </div>
    </div>

    <div v-if="gocheck3 == true" class="check1">
      <div class="checkback"></div>
      <div class="checkkuang">
        <div class="checkicon"><img src="../../assets/images/checkicon.png" alt="" class="con"></div>
        <div class="checktitle">提醒</div>
        <div class="checkinner">感谢关注!本内容仅对特定用户开放，请您输入手机号验证身份后观看，谢谢!</div>
        <div class="checkinput">
          <el-input v-model="phone" class="cheinpt" placeholder="请输入您的手机号"></el-input>
        </div>
        <div class="btrowi">
          <div class="clo" @click="gocheck3 = false">取消</div>
          <div class="jum" @click="upphone()">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import SharePanel from '@/components/sharePanel.vue'
export default {
  name: 'program',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      details: {},
      constab: 1,
      SubjectTCode: 1,
      list: [],
      PageIndex: 0,
      PageSize: 10,
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
        callback: this.upCallback, // 上拉回调
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10 //每页数据条数,默认10
        },
        noMoreSize: 0,
        toTop: {
          // warpId: 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        }
      },
      showSharePanel: false,
      listword: "",
      subList: [],
      bannerlist: [],
      canshu: "",
      gocheck: false,
      gocheck1: false,
      gocheck2: false,
      gocheck3: false,
      bmdid: "",
      phone: "",
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    SharePanel
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    tcode() {
      return this.$route.query.tcode;
    },
  },
  watch: {
    SubjectTCode() {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
  },
  created() {
    document.title = "华肤荟专区";
    this.getBanner();
    this.getsub();
    this.$store.commit("changeNavbarIndex", 2);
    this.initShare("华肤荟专区");
    if (this.code) {
      this.getColumn();
    }
  },
  methods: {
    toBanner(type, url, id) {
      if (type == 20) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '栏目Banner',
            TCode: 'subject_banner',
            Rid: id,
          }).then(res => {
            this.$router.push({
              path: 'live',
              query: {
                id: url,
                type: 1
              }
            });
          })
      } else {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '栏目Banner',
            TCode: 'subject_banner',
            Rid: id,
          }).then(res => {
            location.href = url;
          })
      }
    },
    gohfh() {
      this.gocheck = false;
      this.gocheck1 = false;
      this.gocheck2 = false;
      this.gocheck3 = false;
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      console.log(userInfo)
      if (userInfo && userInfo.Status < 30) {
        this.$router.push({
          path: 'login'
        });
      }
      else if (userInfo && userInfo.Status < 40) {
        this.$router.push({
          path: 'compinfo'
        });
      }
    },
    goacmedzc() {
      this.gocheck = false;
      this.gocheck1 = false;
      this.gocheck2 = false;
      this.gocheck3 = false;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.ACMEDIdentity) {
          this.$router.push({
            path: "/newenterin"
          });
        } else {
          this.$router.push({
            path: '/acmedonly'
          });
        }
      });
    },
    goacmedrz() {
      this.gocheck = false;
      this.gocheck1 = false;
      this.gocheck2 = false;
      this.gocheck3 = false;
      this.$axios.get("/api/api/web/Customer/GetMyInfo").then((res) => {
        if (res.Data.HFHIdentity == '' || res.Data.HFHIdentity == null) {
          this.$router.push({
            path: 'renzhenginfo'
          });
        } else if (res.Data.HFHIdentity != '' && res.Data.HFHIdentity != null && res.Data.HFHIdentity.Status == 0) {
          this.$dialog
            .alert({
              title: "提示",
              message: "认证审核中，请耐心等待",
            })
            .then(() => { });
        }
      });
    },
    upphone() {
      let that = this
      this.$axios.post('/api/api/web/section/CheckWhiteList', {
        SectionId: this.bmdid,
        Mobile: this.phone,
      }).then(res => {
        if (res.Data == false) {
          this.$message({
            showClose: true,
            message: '暂无权限，请稍后再试',
            type: 'error'
          });
        } else {
          this.gocheck = false;
          this.gocheck1 = false;
          this.gocheck2 = false;
          this.gocheck3 = false;
          this.$router.push({
            path: 'sectionlist',
            query: {
              id: that.bmdid,
              isbmd: "1"
            }
          });
        }
      })
    },
    getBanner() {
      let that = this
      this.$axios.get('/api/api/web/content/LiveBannerList?subjectTCode=section|').then(res => {
        that.bannerlist = res.Data;
        console.log()
      })
    },
    getsub() {
      this.$axios.get('/api/api/web/content/LiveSubjectRecommendList').then(res => {
        this.subList = res.Data;
        console.log(this.subList)
      })
    },
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    getColumn() {
      this.$axios.get(`/api/api/web/content/SubjectDetail?code=${this.code}`).then(res => {
        this.details = res.Data;
        this.initBScroll();
        // this.initShare(this.details.Title);
      })
    },
    getList(PageIndex, PageSize) {
      let that = this;
      that.PageIndex = PageIndex;
      that.PageSize = PageSize;
      that.$axios.post('/api/api/web/section/SectionList', {
        PageIndex: that.PageIndex,
        PageSize: that.PageSize,
      }).then(res => {
        if (PageIndex === 1) that.list = []
        that.list = that.list.concat(res.Data.List);
        that.$nextTick(() => {
          that.mescroll.endSuccess(res.Data.List.length)
        })
      })

    },
    yybtnfunc(id) {
      let that = this;
      this.$axios.post('/api/api/web/content/LiveReservation', {
        ArticleId: id
      }).then(res => {
        this.$dialog
          .alert({
            title: "提示",
            message: "预约成功！",
          })
          .then(() => {
            that.getList(1, 10)
          });
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    getsearchword() {
      this.getList(1, 10);
    },
    // 上拉回调
    upCallback(page) {
      this.getList(page.num, page.size);
    },
    toztmore() {
      this.$router.push({
        path: 'ztmoreList',
      });
    },
    toclass(num) {
      this.constab = num
      this.PageIndex = 0
      this.mescrollUp.page.num = 0
      this.list = [];
      this.upCallback(this.mescrollUp.page)
    },
    toDetail(info) {
      console.log('跳转详情')
      if (info.isOuterChain) {
        location.href = info.outerChain;
      } else {
        this.$router.push({
          path: 'informationDetails',
          query: {
            code: info.Code
          }
        });
      }
    },
    toLive(id, tit, img) {
      // console.log("tz")
      let that = this;
      that.bmdid = id
      this.$axios.get(`/api/api/web/section/CheckPermission?SectionId=${id}`).then(res => {
        if (res.Data.CheckPermission == true) {
          this.$router.push({
            path: 'sectionlist',
            query: {
              id: id,
              tit: tit,
              img: img
            }
          });
        } else {
          if (res.Data.AllowHFHRegUser == true) {
            that.gocheck = true
          } else {
            if (res.Data.AllowACMEDUser == true) {
              that.gocheck1 = true
            } else {
              if (res.Data.AllowHFHIdUser == true) {
                that.gocheck2 = true
              } else {
                if (res.Data.AllowWhiteList == true) {
                  that.gocheck3 = true
                } else {
                  that.gocheck3 = true
                }
              }
            }
          }
        }
      })
    },
    closeSharePanel() {
      this.showSharePanel = false;
    },
    guanzhufunc(id, iw) {
      let that = this;
      this.$axios.get('/api/api/web/content/WatchSubject?id=' + id).then(res => {
        console.log(res)
        if (res.RetCode == 10000) {
          if (iw == true) {
            this.$dialog
              .alert({
                title: "提示",
                message: "取关成功！",
              })
              .then(() => {
                this.getsub();
              });
          } else if (iw == false) {
            this.$dialog
              .alert({
                title: "提示",
                message: "关注成功！",
              })
              .then(() => {
                this.getsub();
              });
          }
        } else {
          this.$dialog
            .alert({
              title: "提示",
              message: "操作失败，请稍后再试",
            })
            .then(() => {
            });
        }
      })
    },
    tolivelist(code, Tcode) {
      this.$router.push({
        path: 'liveList',
        query: {
          code: code,
          Tcode: Tcode
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background-color: #f7f8fc;
  padding: 0;
  box-sizing: border-box;

  .banner {
    padding-bottom: 0.3rem;
    padding: 0.3rem 2.5%;

    .banner-swipe {
      .banner-img {
        display: block;
        width: 100%;
      }
    }
  }

  .toptab {
    display: flex;
    flex-direction: row;
    width: 54%;
    background: #f7f8fc;
    margin: auto;
    margin-top: 0.3rem;
    justify-content: space-around;
    border-radius: 50px;
    padding: 0.15rem;
  }

  .square_consult {
    width: 95%;
    margin: auto;

    .square_consult_title {
      color: #1f2b5b;
      font-size: 18px;
      font-weight: 600;
      margin: 15px 0 10px;
    }

    .square_tab_scroll {
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      margin-bottom: 8px;
      margin-top: -6px;
      padding: 6px 0;

      .square_tab_wrapper {
        white-space: nowrap;
      }

      span {
        position: relative;
        color: #435361;
        font-size: 16px;
      }


      span:not(:first-of-type) {
        margin-left: 20px;
      }

      .active {
        color: #1D2A5A;
      }

      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -6px;
        transform: translateX(-16px);
        width: 32px;
        height: 3px;
        border-radius: 3px;
        background: #1f2b5b;
      }
    }

    /* 隐藏水平滚动条 */
    .square_tab_scroll::-webkit-scrollbar {
      display: none;
    }

    .square_consult_box {
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .right_Consult {
        // display: flex;
        border-radius: 8px;
        // box-shadow: 0 5px 8px 0 rgba(0, 0, 0, .04);
        margin-bottom: 12px;
        // padding: 10px;
        // background-color: #FFFFFF;
        box-sizing: border-box;
        // z-index: 20;
        position: relative;
        width: 48.5%;
        // padding-bottom: 1rem;

        .base {
          display: flex;
          flex-direction: column;
          // justify-content: space-between;
          flex: 1;
          padding: 0 3%;
          // position: relative;

          .red {
            color: red;
          }

          .title {
            color: #0c2941;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;

            .top {
              background: #1f2b5b;
              border-radius: 2px;
              font-size: 12px;
              color: #fff;
              padding: 3px;
              margin-right: 5px;
            }
          }

          .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 3%;
            position: absolute;
            left: 8%;
            bottom: 0.3rem;

            .source_box {
              display: flex;
              align-items: center;
              min-width: 25px;
              max-width: 70%;
              height: 25px;
              border-radius: 25px;
              background: #f6f6f6;

              .source_icon {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
                background-color: #fff;
              }

              .source_title {
                font-size: 12px;
                color: #435361;
                margin: 0 10px 0 5px;
              }
            }

            .time {
              font-size: 12px;
              color: #435361;
            }
          }
        }

        .picture {
          flex-shrink: 0;
          width: 100%;
          // height: 80px;
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 0.2rem;
          position: relative;
          // margin-left: 10px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .square_consult_box1 {
      position: relative;

      .right_Consult {
        // display: flex;
        border-radius: 8px;
        box-shadow: 0 5px 8px 0 rgba(0, 0, 0, .04);
        margin-bottom: 10px;
        padding: 10px;
        background-color: #FFFFFF;
        box-sizing: border-box;
        z-index: 20;
        position: relative;

        .base {
          display: flex;
          flex-direction: column;
          // justify-content: space-between;
          flex: 1;
          padding: 0 3%;
          justify-content: space-between;
          // position: relative;

          .red {
            color: red;
          }

          .title {
            color: #0c2941;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;

            .top {
              background: #1f2b5b;
              border-radius: 2px;
              font-size: 12px;
              color: #fff;
              padding: 3px;
              margin-right: 5px;
            }
          }

          .info {
            display: flex;
            justify-content: start;
            align-items: center;
            margin-top: 3%;

            .source_box {
              display: flex;
              align-items: center;
              min-width: 25px;
              max-width: 70%;
              height: 25px;
              border-radius: 25px;
              background: #f6f6f6;

              .source_icon {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
                background-color: #fff;
              }

              .source_title {
                font-size: 12px;
                color: #435361;
                margin: 0 10px 0 5px;
              }
            }

            .time {
              font-size: 12px;
              color: #435361;
            }
          }
        }

        .picture {
          flex-shrink: 0;
          width: 45%;
          // height: 80px;
          border-radius: 10px;
          overflow: hidden;
          // margin-left: 10px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .share {
    position: fixed;
    right: 10px;
    bottom: 120px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
}

.searchrow {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.srowleft {
  width: 79%;
}

.srowright {
  width: 19%;
}

.searchinput {
  width: 100%;
  border: 1px solid rgb(35, 41, 95);
  border-radius: 5px;
  padding: .1rem .2rem;
  box-sizing: border-box;
  background: rgb(247, 248, 252);
}

.searchbtn {
  width: 100%;
  border: 0;
  background: rgb(35, 41, 95);
  color: #fff;
  border-radius: 5px;
  padding: .1rem 0;
}

.square_consult_title {
  color: #1f2b5b;
  font-size: 18px;
  font-weight: 600;
  margin: 15px 0 10px;
  position: relative;
}

.ztxscroll {
  width: 100%;
  overflow-x: scroll;
  padding-bottom: 0.3rem;
  position: relative;
  z-index: 99;
  white-space: nowrap;
}

.ztx_item {
  width: 100%;
  background: #fff;
  border-radius: 0.266667rem;
  margin-right: 0.5rem;
  position: relative;
  z-index: 50;
  display: inline-block;
}

.ztximg {
  display: block;
  width: 100%;
}

.ztxrow {
  display: flex;
  flex-direction: row;
  padding: 0.3rem 0.2rem;
}

.ztxtitle {
  width: 78%;
  color: #1f2b5b;
  margin-right: 2%;
  display: flex;
  align-items: center;
}

.ztxbtnout {
  width: 20%;
  text-align: center;
}

.ztxguanzhu {
  background: #23295f;
  border: 0;
  color: #fff;
  width: 100%;
  padding: 0.2rem 0;
}

.ztmore {
  font-size: .4rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.livetiaozhuan {
  display: flex;
  flex-direction: column;
}

.livetiaozhuan1 {
  display: flex;
  flex-direction: row;
}

.yybtn {
  background: rgb(36, 41, 95);
  color: #fff;
  font-size: .42rem;
  border: 0;
  padding: 0.05rem 0.2rem;
  z-index: 99;
  position: relative;
  border-radius: 3px;
  width: 40%;
  transform: translateX(10px);
}

.yybtndisable {
  background: unset;
  color: #ddd;
  font-size: .42rem;
  border: 0;
  padding: 0.05rem 0.2rem;
  z-index: 99;
  position: relative;
  border-radius: 3px;
  width: 40%;
  transform: translateX(10px);
}

.worktype {
  bottom: 2%;
  position: absolute;
  font-size: 17px;
  color: #959595;
  right: 1%;
  z-index: 99;
}

.yytype {
  width: 100%;
  text-align: right;
}

.toptabinner {
  padding: 0.1rem 0.1rem;
  box-sizing: border-box;
  font-size: .45rem;
  color: #6E6E96;
  font-weight: bold;
  width: 50%;
  text-align: center;
}

.topact {
  background: #fff;
  color: #1D2A5A;
  border-radius: 50px;
}

.instab {
  font-size: .3rem;
  background: #F5F6FA;
  color: #435361;
  padding: 0.07rem 0.15rem;
  border-radius: 5px;
  margin-right: 0.1rem;
}

.check1 {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999;

  .checkback {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }

  .checkkuang {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999999;
    background: #fff;
    width: 90%;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 0.5rem;
    padding-top: 1.3rem;

    .checkicon {
      width: 20%;
      padding: 0.2rem;
      background: #fff;
      border-radius: 10rem;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 0;

      .con {
        display: block;
        width: 100%;
      }
    }

    .checktitle {
      font-size: 0.5rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.5rem;
    }

    .checkinner {
      margin-bottom: 0.5rem;
    }
  }
}

.btrowi {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.clo {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #838383;
}

.jum {
  width: 47%;
  text-align: center;
  border-radius: 10rem;
  border: 1px solid #ddd;
  padding: 0.2rem 0;
  color: #fff;
  background-image: linear-gradient(to right, rgb(75, 185, 248), rgb(39, 101, 236));
}

.cheinpt {
  margin-bottom: 0.5rem;
}

.play {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20% !important;
  height: auto !important;
}

.bannerimg {
  width: 100%;
  display: block;
}
</style>